import React, { useContext, useEffect, useState } from "react";
import ActivateGiftCardForm from "../components/giftCard/activate-giftcard/ActivateGiftCardForm";
import LoadGiftCardForm from "../components/giftCard/activate-giftcard/LoadGiftCardForm";
import StepsProgressBar from "../components/giftCard/shared/StepsProgressBar";
import { AppSettingContext } from "../components/Application";
import DataService from "../services/DataService.service";
import * as GlobalConstants from "../constants/global";
import { IActivateBasketFullModel } from "../models/ActivateGiftCard.model";
import LoadingComponent from "../components/shared/LoadingComponent";
import LoadAndPayForm from "../components/giftCard/activate-giftcard/LoadAndPayForm";

const ActivateGiftCardPage = () => {
    const { labels } = useContext(AppSettingContext);

    const [isLoading, setIsLoading] = useState(true);
    const [currentStep, setCurrentStep] = useState("activate");
    const [basketData, setBasketData] = useState<IActivateBasketFullModel>();
    const [actNumber, setActNumber] = useState("");

    useEffect(() => {
        setIsLoading(true);

        const checkBasketCache = async (basketId: string) => {
            const response = await DataService.getActivateGiftCardBasket(basketId);

            if (response && response.activationNo) {
                setActNumber(response.activationNo);
            }

            setBasketData(response);
            setIsLoading(false);
        };

        const basketId = localStorage.getItem(GlobalConstants.LOCALSTORAGE_KEY_ACTIVATE_BASKET_ID);
        if (basketId) {
            checkBasketCache(basketId);
        } else {
            setIsLoading(false);
        }
    }, []);

    const appElement = document.getElementById('app');
    const sideBarImgSrc = appElement?.getAttribute("data-sidebar-img-src");
    const sideBarImgName = appElement?.getAttribute("data-sidebar-img-name");

    return (
        <>
            {isLoading ? (
                <LoadingComponent />
            ) : (
                <>
                    <div className="container">
                        <StepsProgressBar stepsCount={3} currentStep={currentStep === "activate" ? 1 : currentStep === "load" ? 2 : 3} />

                        <div className="flex-container">
                            <div className="forms">
                                <h2>{labels.get("GiftCard.App.ActivateLoadCard.Title")}</h2>

                                <ActivateGiftCardForm
                                    cacheActNum={basketData?.activationNo ?? ""}
                                    proceedToNextStep={() => {
                                        setCurrentStep("load");

                                        if (basketData && basketData.activationNo !== actNumber) {
                                            setBasketData(null);
                                            DataService.clearBasketCache(basketData.basketId);
                                        }
                                    }}
                                    handleActNumberUpdate={(actNumber) => {
                                        setCurrentStep("activate");
                                        setActNumber(actNumber);
                                    }}
                                />

                                <LoadGiftCardForm
                                    currentStep={currentStep}
                                    activationNumber={actNumber}
                                    basketData={basketData}
                                    setBasketData={(basketData: IActivateBasketFullModel) => setBasketData(basketData)}
                                    proceedToNextStep={() => setCurrentStep("pay")}
                                    handleSetCurrentStep={() => setCurrentStep("load")}
                                />

                                <LoadAndPayForm
                                    loadAmount={basketData?.totalAmount ? basketData.totalAmount.toFixed(2) : "0.00"}
                                    basketData={basketData}
                                    isSectionActive={currentStep === "pay"}
                                />

                                {currentStep === 'activate' && (
                                    <>
                                        <div className="info-container box">
                                            <h6>{labels.get("GiftCard.App.ActivateLoadCard.Tips.HowToActivateQuestion")}</h6>
                                            <p>{labels.get("GiftCard.App.ActivateLoadCard.Tips.HowToActivateAnswer")}</p>
                                        </div>
                                    </>
                                )}
                            </div>


                            <div className="sidebar">
                                {sideBarImgSrc && (
                                    <>
                                        <label htmlFor="mobile-card-preview" className="activateCard-popup-closeBtn">
                                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3 29L29 3M3 3L29 29" stroke="#111827" strokeWidth="2.67" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </label>
                                        <div className="my-card">
                                            <div className="card-animation flex-align-middle">
                                                <img
                                                    src={sideBarImgSrc}
                                                    className="sidebar-physical-img"
                                                    alt={sideBarImgName}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default ActivateGiftCardPage;
